import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { flushSync } from 'react-dom';
import { Drawer, Button, message } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import back from 'asset/img/back.png';
import food from 'asset/img/food.svg';
import fight from 'asset/img/fight.svg';
import dailySvg from 'asset/pet/hurgay/daily.svg';
import btn from 'asset/img/pet-btn.webp';
import { useNavigate } from 'react-router-dom';
import WkModal from 'components/Modal'
import food1 from 'asset/img/pet-food1.webp';
import food2 from 'asset/img/pet-food2.webp';
import food3 from 'asset/img/pet-food3.webp';
import food4 from 'asset/img/pet-food4.webp';
import record from 'asset/img/pet-record.png';
// import feed from 'asset/music/feed.mp3'; // 已替换为 skill 1-4.MP3
import { playFeedSoundByIndex, playHungryAudio, stopPetAudio, unlockPetAudio } from 'utils/soundEffect';
import { OssOther, ossImageCompress, ossImageUrl } from 'utils/const.js';
import { calcSkill } from 'utils';
import magic from 'asset/img/pet-magic.png';
// 挨饿图按霢加载，仅在实际需要时 import 对应 phase
import './index.scss';
import { Tooltip } from 'antd';
import { CustomDrawer } from './CustomDrawer/index.jsx';
import PetStoneIntro from './PetStoneIntro';
import WukongImage from './WukongImage';
import Loadding from 'components/Loadding';
import { getGardenInfo, gardenPeFeed, storeExchangeRecord, getCourseList, getUserInfo } from 'network';
import { savePetInfoToStorage, isInFeedCooldown, setLastFeedAt, getIsHungryPersisted, setIsHungryPersisted } from 'utils/petStorage';
import {
    MAX_PET_PHASE,
    HUNGRY_DISABLED_PHASE,
    PET_PHASE_RECORDS,
    getPetBackgroundSrc,
    getPetFeedSrc,
    getPetIdleSrc,
    isHungryDisabledPhase,
    isMaxPetPhase,
    normalizeGardenInfoForPetPreview,
} from './petPhaseConfig';

const PET_STONE_INTRO_KEY = 'pet_stone_intro_done';

// 静数据移到组件外部，避免每次渲染重新创建
const SKILL_DESCRIPTIONS = [
    { des: '悟空用火眼金睛帮你找出答案' },
    { des: '悟空用魔法增加了抽奖的金币数量' },
    { des: '悟空用魔法增加了抽奖的幸运值' },
    { des: '悟空用魔法让闯关成功多一颗星星' },
];

const INITIAL_ITEMS = [
    { goods_id: "72db4051-7fc7-44ad-a4df-e16a3c21d478", image: food1, num: 0, max: 0, name: '香蕉', _name: '火焰果粒脆' },
    { goods_id: "3cc68a42-529c-4b2a-8d0b-1db08b55e6cf", image: food2, num: 0, max: 0, name: '蟠桃', _name: '炽热能量球' },
    { goods_id: "3a4c0427-c8d6-48ad-9c8e-386f5737efcf", image: food3, num: 0, max: 0, name: '人参果', _name: '彩虹羽翼片' },
    { goods_id: "b4da0908-4aea-40b4-b20d-e88ddc42e22d", image: food4, num: 0, max: 0, name: '老君仙丹', _name: '烈焰成长豆' },
];

/** 根据已食物列表计算最高索引，用于播放对应音效?/2/3/4 -> index 0/1/2/3?*/
const getMaxFedIndex = (fedItems) => {
    let max = -1;
    fedItems.forEach((item) => {
        const idx = INITIAL_ITEMS.findIndex((i) => i.goods_id === item.goods_id);
        if (idx >= 0 && idx > max) max = idx;
    });
    return max;
};

// serial_id -> (type, index)，与 calcSerial 对应
const SERIAL_TO_TYPE_INDEX = { 7: [0, 0], 10: [0, 1], 11: [0, 2], 12: [0, 3], 13: [1, 0], 14: [1, 1], 15: [1, 2], 20: [1, 3], 21: [2, 0], 22: [2, 1], 23: [2, 2], 24: [2, 3] };
const ORDERED_SERIALS = [7, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24];
// ?Home 完全丢致：用同丢?updateList + arrowList，取「带箭头的那丢项的 serial_id 再转 type/index
const getLatestMenuTypeIndex = (courseList, area) => {
    if (!courseList || courseList.length === 0) return { type: 0, index: 0 };
    let permssion;
    try {
        permssion = area ? JSON.parse(area) : [];
    } catch (e) {
        permssion = [];
    }
    if (!Array.isArray(permssion)) permssion = [];
    const updateList = (arr) => {
        for (let i = 1; i < arr.length; i++) {
            const prev = arr[i - 1];
            const cur = arr[i];
            const inPerm = permssion.some((p) => Number(p) === Number(cur.serial_id));
            arr[i] = { ...cur, status: prev.curr_step >= 500 || inPerm };
        }
        if (arr.length > 0) arr[0] = { ...arr[0], status: true };
        return arr;
    };
    const arrowList = (arr) => {
        arr.forEach((item) => { item.arrow = false; });
        const permArr = Array.isArray(permssion) ? permssion : [];
        const hasArea = permArr.length > 0;
        if (hasArea) {
            const lastIdx = Math.max(-1, ...permArr.map((s) => ORDERED_SERIALS.indexOf(Number(s))).filter((i) => i >= 0));
            const targetSerial = lastIdx >= 0 ? ORDERED_SERIALS[lastIdx] : ORDERED_SERIALS[0];
            const targetItem = arr.find((item) => Number(item.serial_id) === targetSerial);
            if (targetItem) targetItem.arrow = true;
        } else {
            let lastTrueIndex = -1;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].status === true) lastTrueIndex = i;
            }
            if (lastTrueIndex !== -1) arr[lastTrueIndex].arrow = true;
        }
        return arr;
    };
    const list = arrowList(updateList(courseList.map((item) => ({ ...item }))));
    const arrowItem = list.find((item) => item.arrow);
    const serialId = arrowItem != null ? Number(arrowItem.serial_id) : ORDERED_SERIALS[0];
    const pair = SERIAL_TO_TYPE_INDEX[serialId];
    if (pair) return { type: pair[0], index: pair[1] };
    return { type: 0, index: 0 };
};

const Pet = () => {
    const isMountedRef = useRef(true);
    const firstLoadFlag = useRef(true);
    const [latestMenu, setLatestMenu] = useState({ type: 0, index: 0 }); // 朢新关?menu ?type、index
    const [showStoneIntro, setShowStoneIntro] = useState(() => {
        try {
            return localStorage.getItem(PET_STONE_INTRO_KEY) !== '1';
        } catch (e) {
            return true;
        }
    });
    const infoFlag = useRef(0);
    const timerRefs = useRef([]);
    const gardenRequestIdRef = useRef(0);
    const [bkImg, setbkImg] = useState('');
    const [visible, setVisible] = useState(false);
    const [topVisible, setTopVisible] = useState(false);
    const [bottomVisible, setBottomVisible] = useState(false);
    const [firstFeedTaskBubbleVisible, setFirstFeedTaskBubbleVisible] = useState(false);
    const [firstClaimChuangBubbleVisible, setFirstClaimChuangBubbleVisible] = useState(false);
    const [gifList, setGifList] = useState([]);
    const [skillList, setskillList] = useState();
    const [imgage, setImage] = useState('');
    // const audioRef = useRef(null); // 投喂音效已改?playFeedSoundByIndex
    const upgradeRef = useRef(null);
    const [info, setInfo] = useState({});
    const [gardenLoaded, setGardenLoaded] = useState(false); // 首屏?getGardenInfo 回来后再展示内容，避免闪屏并节省首帧内存
    const [progress, setProgress] = useState(0);
    const [wukongName, setWukongName] = useState('幼年悟空');
    const [isHungry, setIsHungry] = useState(() => getIsHungryPersisted()); // 挨饿状持久化：切出再进仍保持
    const [hurgayImgSrc, setHurgayImgSrc] = useState(''); // 挨饿图按霢加载
    const [audioUnlocked, setAudioUnlocked] = useState(() => !('ontouchstart' in window));
    const hasHungryTriggeredRef = useRef(false);
    const canShowHungry = isHungry && !isHungryDisabledPhase(info?.PetInfo?.Phase);
    const isPetPreviewMode = useMemo(() => {
        try {
            const previewPhase = Number(new URL(window.location.href).searchParams.get('previewPhase') || 0);
            return previewPhase >= 1 && previewPhase <= MAX_PET_PHASE;
        } catch (e) {
            return false;
        }
    }, []);

    useEffect(() => {
        let previewPhase = 0;
        try {
            previewPhase = Number(new URL(window.location.href).searchParams.get('previewPhase') || 0);
        } catch (e) {
            previewPhase = 0;
        }
        if (previewPhase >= 1 && previewPhase <= MAX_PET_PHASE) {
            setIsHungry(false);
            setIsHungryPersisted(false);
        }
    }, []);
    // 挨饿图懒加载：仅?isHungry ?phase 有效时按霢 import
    useEffect(() => {
        if (!isHungry) {
            setHurgayImgSrc('');
            return;
        }
        const phase = Number(info?.PetInfo?.Phase);
        const p = Math.min(HUNGRY_DISABLED_PHASE - 1, Math.max(1, phase));
        if (!Number.isInteger(phase) || phase < 1 || isHungryDisabledPhase(phase)) {
            setHurgayImgSrc('');
            return;
        }
        let cancelled = false;
        import(`asset/pet/hurgay/${p}.webp`)
            .then((m) => {
                if (!cancelled && isMountedRef.current) setHurgayImgSrc(m.default || '');
            })
            .catch(() => {});
        return () => { cancelled = true; };
    }, [isHungry, info?.PetInfo?.Phase]);
    
    // 监听 info 变化，自动更新进度条（确保喂养后进度条立即更新）
    useEffect(() => {
        if (!info || !info.PetInfo || typeof info.rela_energy_used !== 'number') return;
        
        const maxMinDiff = info.PetInfo.Max - info.PetInfo.Min;
        if (maxMinDiff > 0) {
            const newProgress = Math.min(1, Math.max(0, info.rela_energy_used / maxMinDiff));
            setProgress(newProgress);
        } else {
            setProgress(1); // 满级
        }
    }, [info]);

    // ????????
    useEffect(() => {
        if (isHungryDisabledPhase(info?.PetInfo?.Phase) && isHungry) {
            setIsHungry(false);
            setIsHungryPersisted(false);
        }
    }, [info?.PetInfo?.Phase, isHungry]);

    const [skillVisible, setSkillVisible] = useState(false);
    // 使用函数初始化，避免每次渲染重新创建
    const [items, setItems] = useState(() => INITIAL_ITEMS.map(item => ({ ...item })));
    // ?????????????
    const [refetchTrigger, setRefetchTrigger] = useState(0);
    const [feedVersion, setFeedVersion] = useState(0);
    let navigate = useNavigate();

    // ?pet 离开（返?/ 闯关）：直接跳转，不再展示右?loading
    const goFromPet = useCallback((path, search = '') => {
        navigate(search ? `${path}${search}` : path);
    }, [navigate]);

    const handleBack = useCallback(() => {
        goFromPet('/home');
    }, [goFromPet]);

    const gotoFoodList = useCallback(() => {
        setTopVisible(false);
        localStorage.setItem('pet-top', 'true');
        navigate(`/foodList`);
    }, [navigate]);
    
    // ??? setTimeout?????
    const safeSetTimeout = useCallback((callback, delay) => {
        const timerId = setTimeout(() => {
            if (isMountedRef.current) {
                callback();
            }
        }, delay);
        timerRefs.current.push(timerId);
        return timerId;
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        
        const fetchData = () => {
            const id = ++gardenRequestIdRef.current;
            getGardenInfo({}).then(item => {
                if (id !== gardenRequestIdRef.current || !isMountedRef.current) return;
                
                // 更新 localStorage
                if (item?.data) {
                    savePetInfoToStorage(item.data);
                }
                
                const gardenInfo = normalizeGardenInfoForPetPreview(item?.data?.garden_info);
                const phase = gardenInfo?.PetInfo?.Phase;

                let skill = calcSkill(phase);
                skill = skill?.map((skillItem, index) => {
                    return { ...skillItem, des: SKILL_DESCRIPTIONS[index]?.des };
                });
                setskillList(skill);
                setbkImg(ossImageCompress(getPetBackgroundSrc(phase), 800));
                if (!getIsHungryPersisted()) setImage(getPetIdleSrc(phase));
                
                // ???
                if (infoFlag.current !== phase && !firstLoadFlag.current) {
                    message.info('悟空升级，技能得到了强化!');
                    upgradeRef.current?.play();
                    safeSetTimeout(() => {
                        setImage(getPetIdleSrc(phase));
                    }, 3100);
                } else if (!firstLoadFlag.current) {
                    message.info('投喂成功！');
                    setImage(getPetFeedSrc(phase));
                    playFeedSoundByIndex(3);
                    safeSetTimeout(() => {
                        setImage(getPetIdleSrc(phase));
                    }, 3100);
                }
                firstLoadFlag.current = false;
                setInfo(gardenInfo);
                // 进度条会通过 useEffect 自动更新
                setWukongName(PET_PHASE_RECORDS[phase - 1]?.name);
                
                safeSetTimeout(() => {
                    const giflist = [getPetFeedSrc(phase)];
                    setGifList(giflist);
                }, 2000);
                setGardenLoaded(true);
            }).catch(() => {
                if (isMountedRef.current) setGardenLoaded(true);
            });
            
            storeExchangeRecord({ page: 1, size: 10 }).then(res => {
                if (!isMountedRef.current) return;
                
                setItems(prevItems => {
                    return prevItems.map(itemA => {
                        const itemB = res?.data?.exchange_list?.find(item => item.goods_name === itemA._name);
                        if (itemB) {
                            return { ...itemA, max: itemB?.xch_num - itemB?.used_num };
                        }
                        return itemA;
                    });
                });
            });
        };
        
        fetchData();
        
        // 清理函数
        return () => {
            isMountedRef.current = false;
            timerRefs.current.forEach(timerId => clearTimeout(timerId));
            timerRefs.current = [];
            stopPetAudio();
            };
    }, [safeSetTimeout]);
    
    // 处理数据重新获取
    useEffect(() => {
        if (refetchTrigger === 0) return; // 跳过初始渲染
        
        console.log('触发数据重新获取，refetchTrigger:', refetchTrigger);
        
        let isCancelled = false;
        const id = ++gardenRequestIdRef.current;
        
        getGardenInfo({}).then(item => {
            if (id !== gardenRequestIdRef.current || !isMountedRef.current || isCancelled) return;
            
            console.log('获取到新的宠物信?', item?.data?.garden_info);
            
            // 更新 localStorage
            if (item?.data) {
                savePetInfoToStorage(item.data);
            }
            
            const gardenInfo = normalizeGardenInfoForPetPreview(item?.data?.garden_info);
            if (!gardenInfo) {
                console.warn('gardenInfo为空，无法更新');
                return;
            }
            
            const phase = gardenInfo?.PetInfo?.Phase;

            let skill = calcSkill(phase);
            skill = skill?.map((skillItem, index) => {
                return { ...skillItem, des: SKILL_DESCRIPTIONS[index]?.des };
            });
            setskillList(skill);
            setbkImg(ossImageCompress(getPetBackgroundSrc(phase), 800));
            
            // ???
            if (infoFlag.current !== phase) {
                message.info('悟空升级，技能得到了强化!');
                stopPetAudio();
                upgradeRef.current?.play();
                safeSetTimeout(() => {
                    if (!isCancelled && isMountedRef.current) {
                        setImage(getPetIdleSrc(phase));
                    }
                }, 3100);
                // 升级后更新infoFlag
                infoFlag.current = phase;
            } else {
                message.info('投喂成功！');
                setImage(getPetFeedSrc(phase));
                playFeedSoundByIndex(3);
                safeSetTimeout(() => {
                    if (!isCancelled && isMountedRef.current) {
                        setImage(getPetIdleSrc(phase));
                    }
                }, 3100);
            }
            
            // 更新扢有状态（进度条会通过 useEffect 自动更新?            setInfo(gardenInfo);
            setWukongName(PET_PHASE_RECORDS[phase - 1]?.name);
        }).catch(err => {
            console.error('获取宠物信息失败:', err);
            message.error('获取宠物信息失败，请刷新页面');
        });
        
        return () => {
            isCancelled = true;
        };
        
        storeExchangeRecord({ page: 1, size: 10 }).then(res => {
            if (!isMountedRef.current) return;
            
            setItems(prevItems => {
                return prevItems.map(itemA => {
                    const itemB = res?.data?.exchange_list?.find(item => item.goods_name === itemA._name);
                    if (itemB) {
                        return { ...itemA, max: itemB?.xch_num - itemB?.used_num };
                    }
                    return itemA;
                });
            });
        });
    }, [refetchTrigger, safeSetTimeout]);

    // 拉取朢新关?menu ?type、index（与 Home 箭头扢指一致）
    useEffect(() => {
        let isMounted = true;
        Promise.all([getUserInfo({}), getCourseList({})]).then(([userRes, courseRes]) => {
            if (!isMounted || !isMountedRef.current) return;
            const list = courseRes?.data?.course_list;
            const area = userRes?.data?.area;
            setLatestMenu(getLatestMenuTypeIndex(list || [], area));
        }).catch(() => {});
        return () => { isMounted = false; };
    }, []);

    // 挨饿逻辑：校验投喂标记与冷却期（时间戳，不用 setTimeout?    // - 展示 stone 时暂停挨饿（不计时不触发挨饿?    // - 满级（phase 12）不挨饿
    // - 已在挨饿（持久化）→ 保持，不重复触发
    // ???????????????
    const isStoneVisible = showStoneIntro && Number(info?.energy_used) === 0;

    useEffect(() => {
        if (!gardenLoaded || !isStoneVisible) return;
        window.dispatchEvent(new CustomEvent('pet-bgm-pause'));
    }, [gardenLoaded, isStoneVisible]);

    useEffect(() => {
        if (isPetPreviewMode) return;
        if (isStoneVisible) return; // stone 展示时停止挨饿辑
        const phase = info?.PetInfo?.Phase;
        if (!phase || phase < 1 || isHungryDisabledPhase(phase)) return;
        if (getIsHungryPersisted()) return;
        if (isInFeedCooldown()) return;
        if (hasHungryTriggeredRef.current) return;
        hasHungryTriggeredRef.current = true;
        const t = setTimeout(() => {
            if (!isMountedRef.current) return;
            // ???????????
            if (isInFeedCooldown()) {
                hasHungryTriggeredRef.current = false;
                return;
            }
            if (getIsHungryPersisted()) return;
            setIsHungry(true);
            setIsHungryPersisted(true);
            }, 3000);
        timerRefs.current.push(t);
        return () => clearTimeout(t);
    }, [info?.PetInfo?.Phase, isStoneVisible, isPetPreviewMode]);

    // 挨饿状下：首次立即播放，每次播放完后再隔 5 秒播放下丢条；满级 12 不播（stone 展示时不播）
    useEffect(() => {
        if (isPetPreviewMode) return;
        if (isStoneVisible) return;
        if (!isHungry) return;
        const phase = info?.PetInfo?.Phase;
        if (!phase || phase < 1 || isHungryDisabledPhase(phase)) return;
        let cancelled = false;
        let nextTimerId = null;
        const run = () => {
            if (cancelled || !isMountedRef.current) return;
            playHungryAudio(phase).then(() => {
                if (cancelled || !isMountedRef.current) return;
                nextTimerId = setTimeout(run, 5000);
            });
        };
        // 首次立即播放，播放完后再隔 5 秒播放下一条
        run();
        return () => {
            cancelled = true;
            if (nextTimerId) clearTimeout(nextTimerId);
        };
    }, [isHungry, info?.PetInfo?.Phase, isStoneVisible, isPetPreviewMode]);

    useEffect(() => {
        let top;
        try {
            const item = localStorage.getItem('pet-top');
            top = item ? JSON.parse(item) : null;
        } catch (error) {
            // 解析失败时，可能是因为不是有效的 JSON，提供一个默认?            console.error('Error parsing localStorage item:', error);
            top = null; // 或你可以设置?true/false，根据你的应用辑
        }
        let bottom;
        try {
            const item = localStorage.getItem('pet-bottom');
            bottom = item ? JSON.parse(item) : null;
        } catch (error) {
            // 解析失败时，可能是因为不是有效的 JSON，提供一个默认?            console.error('Error parsing localStorage item:', error);
            bottom = null; // 或你可以设置?true/false，根据你的应用辑
        }

        console.log(top, bottom, 'ppq')
        !top && setTopVisible(true)
        !bottom && top && setBottomVisible(true)
    }, [topVisible, bottomVisible]);

    // ????????
    useEffect(() => {
        try {
            if (localStorage.getItem('pet_first_feed_done') !== '1') return;
            if (localStorage.getItem('pet_first_feed_task_bubble_seen') === '1') return;
            setFirstFeedTaskBubbleVisible(true);
        } catch (e) {}
    }, []);

    // 首次领取任务：每日任务页会存 pet_first_task_claimed；未看过「去闯关」气泡则展示
    useEffect(() => {
        try {
            if (localStorage.getItem('pet_first_task_claimed') !== '1') return;
            if (localStorage.getItem('pet_first_claim_chuang_bubble_seen') === '1') return;
            setFirstClaimChuangBubbleVisible(true);
        } catch (e) {}
    }, []);

    const showDrawer = () => {
        setBottomVisible(false);
        localStorage.setItem('pet-bottom', 'true');
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
        // 可：重置计数?        setItems(prevItems => prevItems.map(item => ({ ...item, num: 0 })));
    };

    const handleIncrement = (_item) => {
        setItems(prevItems =>
            prevItems.map(item =>
                item.goods_id === _item.goods_id ? { ...item, num: item.num + 1 } : item
            )
        );
    };

    const handleDecrement = (_item) => {
        setItems(prevItems =>
            prevItems.map(item =>
                item.goods_id === _item.goods_id ? { ...item, num: Math.max(0, item.num - 1) } : item
            )
        );
    };

    const onOk = useCallback(() => {
        if (isMaxPetPhase(info?.PetInfo?.Phase)) {
            setVisible(false);
            message.info('投喂成功！');
        }
        
        const _items = items.filter(item => item.num !== 0);
        
        if (_items.length === 0) {
            message.info('投喂成功！');
        }
        
        // ???????????????
        const currentPhase = info?.PetInfo?.Phase;
        
        gardenPeFeed({ foods: _items }).then(res => {
            if (!isMountedRef.current) return;
            
            if (res?.code == 1) {
                message.info('投喂成功！');
            } else {
                setVisible(false);
                try {
                    if (!localStorage.getItem('pet_first_feed_done')) {
                        localStorage.setItem('pet_first_feed_done', '1');
                        if (localStorage.getItem('pet_first_feed_task_bubble_seen') !== '1') {
                            const tid = setTimeout(() => {
                                if (isMountedRef.current) setFirstFeedTaskBubbleVisible(true);
                            }, 2000);
                            timerRefs.current.push(tid);
                        }
                    }
                } catch (e) {}
                setLastFeedAt();
                setIsHungryPersisted(false);
                setImage(getPetFeedSrc(currentPhase));
                setIsHungry(false);
                infoFlag.current = currentPhase;
                playFeedSoundByIndex(getMaxFedIndex(_items)); // petfeed 接口通了就播?                
                const prevEnergy = info?.rela_energy_used ?? 0;
                const prevPhase = info?.PetInfo?.Phase ?? 0;
                
                const applyGarden = (gardenInfo) => {
                    if (!gardenInfo?.PetInfo || !isMountedRef.current) return;
                    const maxMin = (gardenInfo.PetInfo.Max - gardenInfo.PetInfo.Min) || 1;
                    const nextProgress = Math.min(1, Math.max(0, (gardenInfo.rela_energy_used ?? 0) / maxMin));
                    flushSync(() => {
                        setInfo({ ...gardenInfo });
                        setProgress(nextProgress);
                        setWukongName(PET_PHASE_RECORDS[gardenInfo.PetInfo.Phase - 1]?.name ?? '幼年悟空');
                        setFeedVersion(v => v + 1);
                    });
                    if (infoFlag.current !== gardenInfo.PetInfo.Phase) {
                        message.info('悟空升级，技能得到了强化!');
                        stopPetAudio(); // 升级时中断投?挨饿音频，只播升级音
                        upgradeRef.current?.play();
                        setbkImg(ossImageCompress(getPetBackgroundSrc(gardenInfo.PetInfo.Phase), 800));
                        setImage(getPetIdleSrc(gardenInfo.PetInfo.Phase));
                        infoFlag.current = gardenInfo.PetInfo.Phase;
                    } else {
                        message.info('投喂成功！');
                        setImage(getPetFeedSrc(gardenInfo.PetInfo.Phase));
                        const t = setTimeout(() => {
                            if (isMountedRef.current) setImage(getPetIdleSrc(gardenInfo.PetInfo.Phase));
                        }, 3100);
                        timerRefs.current.push(t);
                    }
                };
                
                const fetchAndMaybeRetry = (retryCount) => {
                    const id = ++gardenRequestIdRef.current;
                    getGardenInfo({}).then(item => {
                        if (id !== gardenRequestIdRef.current || !isMountedRef.current) return;
                        const g = normalizeGardenInfoForPetPreview(item?.data?.garden_info);
                        if (!g?.PetInfo) return;
                        const curEnergy = g.rela_energy_used ?? 0;
                        const curPhase = g.PetInfo.Phase ?? 0;
                        const isNewer = curEnergy > prevEnergy || curPhase !== prevPhase;
                        if (isNewer || retryCount <= 0) {
                            applyGarden(g);
                            return;
                        }
                        const t2 = setTimeout(() => fetchAndMaybeRetry(0), 280);
                        timerRefs.current.push(t2);
                    });
                };
                
                const t1 = setTimeout(() => fetchAndMaybeRetry(1), 120);
                timerRefs.current.push(t1);
                
                // 立即更新食物库存
                storeExchangeRecord({ page: 1, size: 10 }).then(res => {
                    if (!isMountedRef.current) return;
                    
                    setItems(prevItems => {
                        return prevItems.map(itemA => {
                            const itemB = res?.data?.exchange_list?.find(item => item.goods_name === itemA._name);
                            if (itemB) {
                                return { ...itemA, max: itemB?.xch_num - itemB?.used_num };
                            }
                            return itemA;
                        });
                    });
                });
            }
        }).catch(err => {
            console.error('投喂失败:', err);
            message.error('投喂失败，请重试');
        });
        setItems(prevItems => prevItems.map(item => ({ ...item, num: 0 })));
    }, [info?.PetInfo?.Phase, info?.rela_energy_used, items]);

    const skillOk = () => {
        setSkillVisible(false)
    }

    const skillContent = <div>
        {skillList?.map((item, index) => {
            if (!item.visible) return null
            return (
                <div key={index} className='pet-skillcontent'>
                    <div className='left'>
                        <img src={ossImageUrl(item?.src)} alt='' />
                    </div>
                    <div>
                        <div><span className='title'>名称：</span><span className='des'>{item?.name}</span></div>
                        <div><span className='title'>描述：</span><span className='des'>{item?.des}</span></div>
                        <div><span className='title'>等级：</span><span className='des'>{item?.level}</span></div>
                    </div>
                </div>

            )
        })}
    </div>

    const dom = (<div className='pet-food'>
        <img src={food} onClick={gotoFoodList} />
        <div className='fonts'>食物商城</div>
    </div>)

    const topClose = () => {
        // 关闭气泡，并?localStorage 中设置对应类型的标志?'true'
        setTopVisible(false)
        localStorage.setItem('pet-top', 'true');
    };

    const bottomClose = () => {
        // 关闭气泡，并?localStorage 中设置对应类型的标志?'true'
        setBottomVisible(false)
        localStorage.setItem('pet-bottom', 'true');
    };

    const handleStoneIntroDone = useCallback(() => {
        try {
            localStorage.setItem(PET_STONE_INTRO_KEY, '1');
        } catch (e) {}
        setShowStoneIntro(false);
        window.dispatchEvent(new CustomEvent('pet-bgm-resume'));
    }, []);

    const handlePetInteraction = useCallback(() => {
        if (!audioUnlocked) {
            unlockPetAudio(); // 移动端：首次交互解除音频限制
            setAudioUnlocked(true);
        }
    }, [audioUnlocked]);

    return (
        <div className='pet-container' onClick={handlePetInteraction} onTouchStart={handlePetInteraction}>
            {!gardenLoaded ? (
                <Loadding visible />
            ) : (
                <>
            {showStoneIntro && Number(info?.energy_used) === 0 && (
                <PetStoneIntro onDone={handleStoneIntroDone} />
            )}
            <img src={back} className='pet-back' onClick={handleBack} />
            <div className="pet-right-entries">
                {!isMaxPetPhase(info?.PetInfo?.Phase) && (
                    <Tooltip
                        placement="left"
                        title={
                            <div>
                                {<div>悟空饿啦！给悟空买食物！👉</div>}
                                <Button type="primary" onClick={() => { topClose(); navigate('/foodList'); }} size="small">去买食物</Button>
                                <div style={{ clear: "both" }}></div>
                            </div>
                        }
                        visible={topVisible}
                    >
                        <div className='pet-food'>
                            <img src={food} onClick={gotoFoodList} />
                            <div className='fonts'>食物商城</div>
                        </div>
                    </Tooltip>
                )}
                <div className='pet-magic' onClick={() => { setSkillVisible(true) }}>
                    <img src={magic} alt='' />
                    <div className='fonts'>技能介绍</div>
                </div>
                <div className='pet-record' onClick={() => navigate('/petRecord')}>
                    <img src={record} alt='' />
                    <div className='fonts'>大圣图鉴</div>
                </div>
                {firstFeedTaskBubbleVisible ? (
                    <Tooltip
                        placement="left"
                        title={
                            <div>
                                <div>快领取任务，和悟空一起开始冒险吧</div>
                                <Button type="primary" onClick={() => { try { localStorage.setItem('pet_first_feed_task_bubble_seen', '1'); } catch (e) {} setFirstFeedTaskBubbleVisible(false); navigate('/daily-task'); }} size="small">领取任务</Button>
                                <div style={{ clear: 'both' }} />
                            </div>
                        }
                        visible={true}
                    >
                        <div className='pet-daily-entry' onClick={() => { try { localStorage.setItem('pet_first_feed_task_bubble_seen', '1'); } catch (e) {} setFirstFeedTaskBubbleVisible(false); navigate('/daily-task'); }}>
                            <img src={dailySvg} alt='' />
                            <div className='fonts'>每日任务</div>
                        </div>
                    </Tooltip>
                ) : (
                    <div className='pet-daily-entry' onClick={() => navigate('/daily-task')}>
                        <img src={dailySvg} alt='' />
                        <div className='fonts'>每日任务</div>
                    </div>
                )}
                {firstClaimChuangBubbleVisible ? (
                    <Tooltip
                        placement="left"
                        title={
                            <div>
                                <div>任务领取完成，开始和悟空丢起闯关吧</div>
                                <Button type="primary" onClick={() => { try { localStorage.setItem('pet_first_claim_chuang_bubble_seen', '1'); } catch (e) {} setFirstClaimChuangBubbleVisible(false); goFromPet('/menu', `?type=${latestMenu.type}&index=${latestMenu.index}`); }} size="small">去闯关</Button>
                                <div style={{ clear: 'both' }} />
                            </div>
                        }
                        visible={true}
                    >
                        <div className='pet-menu-entry' onClick={() => { try { localStorage.setItem('pet_first_claim_chuang_bubble_seen', '1'); } catch (e) {} setFirstClaimChuangBubbleVisible(false); goFromPet('/menu', `?type=${latestMenu.type}&index=${latestMenu.index}`); }}>
                            <img src={fight} alt='' />
                            <div className='fonts'>去闯关</div>
                        </div>
                    </Tooltip>
                ) : (
                    <div className='pet-menu-entry' onClick={() => goFromPet('/menu', `?type=${latestMenu.type}&index=${latestMenu.index}`)}>
                        <img src={fight} alt='' />
                            <div className='fonts'>去闯关</div>
                    </div>
                )}
            </div>
            <div className='pet-content'>
                {showStoneIntro && Number(info?.energy_used) === 0 ? null : (
                    <>
                        <WukongImage
                            phase={info?.PetInfo?.Phase}
                            isHungry={canShowHungry}
                            src={ossImageUrl(canShowHungry ? hurgayImgSrc : imgage)}
                        />
                        <div className='pet-progress' key={feedVersion}>
                            <div className='pet-name'>{wukongName}</div>
                            <div
                                className={`progress${!isMaxPetPhase(info?.PetInfo?.Phase) && Number.isFinite(progress) && progress >= 0.85 ? ' progress--almost-full' : ''}`}
                                style={{
                                    '--progress-pct': `${
                                        isMaxPetPhase(info?.PetInfo?.Phase)
                                            ? 100
                                            : Number.isFinite(progress)
                                                ? Math.min(100, Math.max(0, progress * 100))
                                                : 0
                                    }%`
                                }}
                            >
                                <div className='progress-content' />
                                <div className='progress-font'>{isMaxPetPhase(info?.PetInfo?.Phase) ? <span>满级</span> : <>{info?.rela_energy_used} / {info?.PetInfo?.Max - info?.PetInfo?.Min}</>}</div>
                            </div>
                        </div>
                        {!isMaxPetPhase(info?.PetInfo?.Phase) && (
                            <Tooltip
                                placement="bottom"
                                title={
                                    <div>
                                        {<div>喂悟空吃东西，它就能升级进化，变得更强哦！</div>}
                                        <Button type="primary" onClick={() => { bottomClose(); showDrawer(); }} size="small">去喂悟空</Button>
                                        <div style={{ clear: "both" }}></div>
                                    </div>
                                }
                                open={bottomVisible}
                            >
                                <div className='feed-btn' onClick={showDrawer}>
                                    <img src={btn} />
                                </div>
                            </Tooltip>
                        )}
                    </>
                )}
            </div>
            <div className='pet-background' ><img src={bkImg} /></div>
            {/* <Drawer
                title="喂养食物"
                placement="bottom"
                closable={false}
                onClose={onClose}
                open={visible}

                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onClose} style={{ marginRight: '1rem' }}>取消</Button>
                        <Button type="primary" onClick={onOk}>
                            确认
                        </Button>
                    </div>
                }
            >
                <div className='drawer-list'>
                    {items.map(item => (
                        <div className='list-item'>
                            <div className='left'>
                                <div className='img'><img src={item.image} /></div>
                                <div className='font'>
                                    <div className='name'>{item.name} </div>
                                    <div className='num'>数量: <span>{item.max}</span></div>
                                </div>
                            </div>
                            <div className='right'>
                                <Button className='check' onClick={() => handleDecrement(item)} icon={<MinusCircleOutlined />} />
                                <div className='number'>{item.num}</div>
                                <Button className='check' onClick={() => handleIncrement(item)} icon={<PlusOutlined />} />
                            </div>
                        </div>
                    ))}
                </div>
            </Drawer> */}
            <CustomDrawer
                visible={visible}
                items={items.map(item => ({
                ...item,
                onIncrease: () => handleIncrement(item),
                onDecrease: () => handleDecrement(item)
                }))}
                onConfirm={onOk}
                onClose={() => setVisible(false)}
            />
            <WkModal
                visible={skillVisible}
                onOk={skillOk}
                content={skillContent}
                okText={'确定'}
                onCancel={skillOk}
                tongquStyle
            />

            <div className='undisplay'>
                {gifList?.map((item, index) => {
                    return <img src={ossImageUrl(item)} key={index} />
                })}
                {/* 投喂音效已改?playFeedSoundByIndex(skill 1-4.MP3) */}
                <audio src={OssOther + `/image/pet-oss/upgrade.mp3`} controls ref={upgradeRef}></audio>
            </div>
                </>
            )}
        </div>
    );
};

export default Pet;


